/* import __COLOCATED_TEMPLATE__ from './outlet-wrapper.hbs'; */
/* RESPONSIBLE TEAM: team-frontend-tech */

import Component from '@glimmer/component';
import { assert } from '@ember/debug';
import { action } from '@ember/object';

interface Signature {
  Blocks: {
    default: [];
  };
}

export default class ReactOutletWrapper extends Component<Signature> {
  @action assertNotNested(element: HTMLElement) {
    assert(
      'Nested <React::OutletWrapper> detected! Only one instance may be active at a time. ' +
        'Check that your route template does not wrap {{outlet}} in <React::OutletWrapper> ' +
        'when a parent route already does.',
      !element.parentElement?.closest('[data-react-outlet-wrapper]'),
    );
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'React::OutletWrapper': typeof ReactOutletWrapper;
    'react/outletwrapper': typeof ReactOutletWrapper;
  }
}
